import styled from 'styled-components';

export const Content = styled.div`
  padding: 25px;
`;
export const BackButton = styled.div`
  width: fit-content;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  margin-bottom: 20px;
  background: #ffffff;
  border: 0.4px solid #d4d8dd;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #1d3557;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-color: #94a3b8;
  }
`;
export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .add-button {
    height: 38px;
    width: 135px;
  }
`;
export const HeaderTopTitle = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #212529;
`;
export const LeadHeaderCard = styled.div`
  border-radius: 8px;
  border: 0.4px solid #dfdfdf0d;
  background: white;
  padding: 4px 10px 4px 30px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: start;
    padding: 4px 10px;
  }
`;
export const LeadCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
export const CardLeftImg = styled.div`
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #2b7fff 0%, #1d3557 100%);
  box-shadow:
    0px 4px 6px -4px #0000001a,
    0px 10px 15px -3px #0000001a;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CardLeftIcon = styled.img``;
export const LeadInfoLeft = styled.div`
  @media (max-width: 550px) {
    flex: 1;
  }
`;
export const LeadInfoTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const LeadInfoTitle = styled.h3`
  font-weight: 500;
  font-size: 18px;
  line-height: 36px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #212529;
`;
export const EditIconButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;

  img {
    width: 16px;
    height: 16px;
  }

  &:active {
    transform: translateY(0);
  }
`;
export const LeadBadge = styled.div`
  display: flex;
  gap: 8px;
`;
export const BadgeItem = styled.div`
  height: 20px;
  border-radius: 8px;
  background: #faf5ff;
  padding: 0 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #8200db;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.priority {
    background: #ffe2e2;
    color: #c10007;
    gap: 8px;
  }
`;
export const LeadMetaInfo = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #6c757d;
  margin-top: 2px;
`;
export const LeadCardRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  .badge-div {
    display: flex;
    gap: 10px;
  }
  @media (max-width: 991px) {
    width: 100%;
    justify-content: flex-end;
  }
  @media (max-width: 415px) {
    gap: 4px;
    flex-direction: column;
    .badge-div {
      gap: 4px;
      align-self: self-end;
    }
  }
`;
export const BadgeItemStatus = styled.div`
  height: 24px;
  min-width: 82px;
  border-radius: 22px;
  background: #15c7a71a;
  font-family: Nunito;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #15c7a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &.reassign {
    background: #fff0e5;
    color: #ff6a00;
  }
  &.unassign {
    background: #fff0f1;
    color: #fb2c36;
  }
  &.take-lead {
    background: linear-gradient(90deg, #2768cb 31.73%, #224f91 100%);
    color: #ffffff;
    padding: 0 10px;
  }
`;
export const CardRightIcon = styled.img``;
export const InputWrapper = styled.div`
  margin-left: 10px;
  label {
    display: none;
  }
  > div {
    min-height: auto;
  }
  .css-17hzp7b-control,
  .css-mkw8ed-control {
    background: #2d6cdf;
    border: none;
    box-shadow: none;
    cursor: pointer;
    border-radius: 10px;
    min-height: 38px;

    &:hover {
      border: none;
      box-shadow: none;
    }
  }
  .css-evdxjr-placeholder {
    color: white !important;
    font-weight: 700 !important;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
  }
  .css-1xc3v61-indicatorContainer,
  .css-15lsz6c-indicatorContainer {
    padding-left: 0;
    img {
      filter: brightness(0) invert(1);
      width: 12px;
      height: auto;
    }
  }

  [class*='-indicatorSeparator'] {
    display: none;
  }
  @media (max-width: 415px) {
    margin-left: 0;
    align-self: flex-end;
    margin-top: 8px;
  }
`;
export const ContentBox = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
  align-items: start;
  width: 100%;
  background-color: white;
  padding: 32px 10px 32px 32px;
  margin-top: 18px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 10px;
  }
`;

export const LeftColumn = styled.div`
  grid-column: span 9;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1024px) {
    grid-column: span 1;
  }
`;

export const RightColumn = styled.div`
  grid-column: span 3;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1024px) {
    grid-column: span 1;
  }
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #dc3545;
`;

export const EmptyMessage = styled.div`
  padding: 20px;
  text-align: center;
`;
